import { change } from "redux-form";
import React from "react";
import store from "../../store";
import { disableLanguageSelectorToggle } from "../../actions/commonActions";
import { setLocaleWithFallback } from "../../actions/index";
import { preferredLanguageName } from "../../i18n/config";
import { Translate } from "react-redux-i18n";
import throwError from "../errorToast";
import { countryLanguageMapping } from "../../constants/countryLanguageData";

const allLanguageOptions = Array.from(
  new Map(
    Object.values(countryLanguageMapping)
      .flat()
      .map((language) => [language.value, language]),
  ).values(),
);

export default class DataActions {
  static regionAction = (compProps, fieldProps, actionObj, eventType) => {
    const geoPolData = store.getState().common.geoPolData;

    const countryStateMappingStoreData =
      store.getState().common.countryStateMappingData;

    if (eventType === "onLoad") {
      fieldProps.options = Object.values(geoPolData);
    }
    if (eventType === "onChange") {
      compProps.field.map((obj) => {
        // if (obj.name === actionObj.fieldName) {
        //   obj.options = Object.values(geoPolData[fieldProps.val].countries);
        // }
        if (obj.name === actionObj.fieldName) {
          if (
            countryStateMappingStoreData &&
            _.keys(countryStateMappingStoreData)?.length > 0 &&
            "country" in countryStateMappingStoreData &&
            countryStateMappingStoreData?.country?.length > 0
          ) {
            // Get the countries based on the Region
            const filteredCountryForSelectedRegion =
              countryStateMappingStoreData?.country?.length > 0
                ? countryStateMappingStoreData?.country?.filter((cntry) => {
                    return (
                      cntry?.region?.toUpperCase() ===
                      fieldProps.val?.toUpperCase()
                    );
                  })
                : [];

            if (filteredCountryForSelectedRegion?.length > 0) {
              const formattedCountries = [];
              filteredCountryForSelectedRegion.forEach((eachCntry) => {
                formattedCountries.push({
                  label: eachCntry?.value,
                  value: eachCntry?.countryCode,
                });
              });

              // Once the state is formatted, lets sort it
              formattedCountries.sort((a, b) => a.label - b.label);

              // assign it to the options
              obj.options = formattedCountries;
            } else {
              obj.options = [
                {
                  label: "N/A",
                  value: "n/a",
                },
              ];
            }
          } else {
            obj.options = [
              {
                label: "N/A",
                value: "n/a",
              },
            ];
          }
        }
        return null;
      });
    }
  };

  static countryAction = (compProps, fieldProps, actionObj, eventType) => {
    // const geoPolData = store.getState().common.geoPolData;
    const countryStateMappingStoreData =
      store.getState().common.countryStateMappingData;

    if (eventType === "onLoad") {
      if (actionObj.values["geo"]) {
        compProps.field.map((obj) => {
          if (obj.name === fieldProps.name) {
            // obj.options = Object.values(
            //   geoPolData[actionObj.values.geo].countries
            // );
            if (
              countryStateMappingStoreData &&
              _.keys(countryStateMappingStoreData)?.length > 0 &&
              "country" in countryStateMappingStoreData &&
              countryStateMappingStoreData?.country?.length > 0
            ) {
              // Get the countries based on the Region
              const filteredCountryForSelectedRegion =
                countryStateMappingStoreData?.country?.length > 0
                  ? countryStateMappingStoreData?.country?.filter((cntry) => {
                      return (
                        cntry?.region?.toUpperCase() ===
                        actionObj.values?.geo?.toUpperCase()
                      );
                    })
                  : [];

              if (filteredCountryForSelectedRegion?.length > 0) {
                const formattedCountries = [];
                filteredCountryForSelectedRegion.forEach((eachCntry) => {
                  formattedCountries.push({
                    label: eachCntry?.value,
                    value: eachCntry?.countryCode,
                  });
                });

                // Once the state is formatted, lets sort it
                formattedCountries.sort((a, b) => a.label - b.label);

                // assign it to the options
                obj.options = formattedCountries;
              } else {
                obj.options = [
                  {
                    label: "N/A",
                    value: "n/a",
                  },
                ];
              }
            } else {
              obj.options = [
                {
                  label: "N/A",
                  value: "n/a",
                },
              ];
            }
          }
          return null;
        });
      }
    } else if (eventType === "onChange") {
      compProps.field.map((obj) => {
        if (obj.name === actionObj.fieldName) {
          fieldProps.options.map((item) => {
            if (item.value === fieldProps.val) {
              // get the languages from the 'countryLanguageMapping' for the selected country
              const languagesForSelectedCountry =
                countryLanguageMapping[item.value];

              if (languagesForSelectedCountry?.length > 0) {
                obj.options = languagesForSelectedCountry;
              } else {
                obj.options = [
                  {
                    label: "N/A",
                    value: "n/a",
                  },
                ];
              }
            }
            return null;
          });
        }
        return null;
      });
    }
  };

  static languageAction = (compProps, fieldProps, actionObj, eventType) => {
    // const geoPolData = store.getState().common.geoPolData;
    if (eventType === "onLoad") {
      //do nothing on load;
      if (actionObj.values["billingCountry"]) {
        // get the languages from the 'countryLanguageMapping' for the selected country
        const languagesForSelectedCountry =
          countryLanguageMapping[actionObj.values[actionObj.fieldName]];

        if (languagesForSelectedCountry?.length > 0) {
          fieldProps.options = languagesForSelectedCountry;
        } else {
          fieldProps.options = [
            {
              label: "N/A",
              value: "n/a",
            },
          ];
        }

        // fieldProps.options =
        //   geoPolData[actionObj.values["geo"]].countries[
        //     actionObj.values[actionObj.fieldName]
        //   ].languages;
      } else {
        // billingCountry isn't always present (e.g. "Other" contacts only
        // receive a minimal partnerInfo), so fall back to the full language
        // list rather than leaving the select with no options.
        fieldProps.options = allLanguageOptions;
      }
    } else if (eventType === "onChange") {
      //pass
    }
  };

  static setLanguageReg = (compProps, fieldProps, actionObj, eventType) => {
    if (eventType === "onLoad") {
      if (actionObj.values["preferredLanguage_0"]) {
        const finalLocale = Object.keys(preferredLanguageName).includes(
          actionObj.values["preferredLanguage_0"]
        )
          ? preferredLanguageName[actionObj.values["preferredLanguage_0"]]
          : "en_US";
        store.dispatch(setLocaleWithFallback(finalLocale));
        store.dispatch(disableLanguageSelectorToggle(true));
      }
    } else if (eventType === "onChange") {
      if (actionObj.values["preferredLanguage_0"]) {
        const finalLocale = Object.keys(preferredLanguageName).includes(
          actionObj.values["preferredLanguage_0"]
        )
          ? preferredLanguageName[actionObj.values["preferredLanguage_0"]]
          : "en_US";
        store.dispatch(setLocaleWithFallback(finalLocale));
        store.dispatch(disableLanguageSelectorToggle(true));
      }
    }
  };

  static setLanguageMP = (compProps, fieldProps, actionObj, eventType) => {
    const loggedInUser = Boolean(
      actionObj.values["email_" + fieldProps.name.split("_")[1]] &&
        actionObj.values[
          "email_" + fieldProps.name.split("_")[1]
        ].toLowerCase() === window.adobeIMS.getUserProfile().email.toLowerCase()
    );
    if (eventType === "onLoad") {
      if (
        loggedInUser &&
        actionObj.values["preferredLanguage_" + fieldProps.name.split("_")[1]]
      ) {
        const finalLocale = Object.keys(preferredLanguageName).includes(
          actionObj.values["preferredLanguage_" + fieldProps.name.split("_")[1]]
        )
          ? preferredLanguageName[
              actionObj.values[
                "preferredLanguage_" + fieldProps.name.split("_")[1]
              ]
            ]
          : "en_US";
        store.dispatch(setLocaleWithFallback(finalLocale));
        store.dispatch(disableLanguageSelectorToggle(true));
      }
    } else if (eventType === "onChange") {
      if (
        loggedInUser &&
        actionObj.values["preferredLanguage_" + fieldProps.name.split("_")[1]]
      ) {
        const finalLocale = Object.keys(preferredLanguageName).includes(
          actionObj.values["preferredLanguage_" + fieldProps.name.split("_")[1]]
        )
          ? preferredLanguageName[
              actionObj.values[
                "preferredLanguage_" + fieldProps.name.split("_")[1]
              ]
            ]
          : "en_US";
        store.dispatch(setLocaleWithFallback(finalLocale));
        store.dispatch(disableLanguageSelectorToggle(true));
      }
    }
  };

  static setLanguageMPOther = (compProps, fieldProps, actionObj, eventType) => {
    const loggedInUser = Boolean(
      actionObj.values["email"] &&
        actionObj.values["email"].toLowerCase() ===
          window.adobeIMS.getUserProfile().email.toLowerCase()
    );
    if (eventType === "onLoad") {
      if (loggedInUser && actionObj.values["preferredLanguage"]) {
        const finalLocale = Object.keys(preferredLanguageName).includes(
          actionObj.values["preferredLanguage"]
        )
          ? preferredLanguageName[actionObj.values["preferredLanguage"]]
          : "en_US";
        store.dispatch(setLocaleWithFallback(finalLocale));
        store.dispatch(disableLanguageSelectorToggle(true));
      }
    } else if (eventType === "onChange") {
      if (loggedInUser && actionObj.values["preferredLanguage"]) {
        const finalLocale = Object.keys(preferredLanguageName).includes(
          actionObj.values["preferredLanguage"]
        )
          ? preferredLanguageName[actionObj.values["preferredLanguage"]]
          : "en_US";
        store.dispatch(setLocaleWithFallback(finalLocale));
        store.dispatch(disableLanguageSelectorToggle(true));
      }
    }
  };

  static setLanguageUR = (compProps, fieldProps, actionObj, eventType) => {
    const loggedInUser = Boolean(
      actionObj.values["email_" + fieldProps.name.split("_")[1]] &&
        actionObj.values[
          "email_" + fieldProps.name.split("_")[1]
        ].toLowerCase() === window.adobeIMS.getUserProfile().email.toLowerCase()
    );
    if (eventType === "onLoad") {
      if (
        loggedInUser &&
        actionObj.values["preferredLanguage_" + fieldProps.name.split("_")[1]]
      ) {
        const finalLocale = Object.keys(preferredLanguageName).includes(
          actionObj.values["preferredLanguage_" + fieldProps.name.split("_")[1]]
        )
          ? preferredLanguageName[
              actionObj.values[
                "preferredLanguage_" + fieldProps.name.split("_")[1]
              ]
            ]
          : "en_US";
        store.dispatch(setLocaleWithFallback(finalLocale));
        store.dispatch(disableLanguageSelectorToggle(true));
      }
    } else if (eventType === "onChange") {
      if (
        loggedInUser &&
        actionObj.values["preferredLanguage_" + fieldProps.name.split("_")[1]]
      ) {
        const finalLocale = Object.keys(preferredLanguageName).includes(
          actionObj.values["preferredLanguage_" + fieldProps.name.split("_")[1]]
        )
          ? preferredLanguageName[
              actionObj.values[
                "preferredLanguage_" + fieldProps.name.split("_")[1]
              ]
            ]
          : "en_US";
        store.dispatch(setLocaleWithFallback(finalLocale));
        store.dispatch(disableLanguageSelectorToggle(true));
      }
    }
  };

  static setCountryLabel = (compProps, fieldProps, actionObj, eventType) => {
    // const geoPolData = store.getState().common.geoPolData;

    const countryStateMappingStoreData =
      store.getState().common.countryStateMappingData;

    if (eventType === "onLoad") {
      if (
        countryStateMappingStoreData &&
        _.keys(countryStateMappingStoreData)?.length > 0 &&
        "country" in countryStateMappingStoreData &&
        countryStateMappingStoreData?.country?.length > 0
      ) {
        // get all countries for the selected region
        const cntryList = countryStateMappingStoreData?.country?.filter(
          (cntry) => {
            return (
              cntry?.region?.toUpperCase() ===
              actionObj?.values["geo"]?.toUpperCase()
            );
          }
        );

        // get the selected country details
        let cntryLbl = "";
        if (cntryList?.length > 0) {
          const selCntry = cntryList?.filter((cntry) => {
            return (
              cntry?.countryCode?.toUpperCase() ===
              actionObj?.values[actionObj.fieldName]?.toUpperCase()
            );
          });

          if (selCntry?.length > 0) {
            cntryLbl = selCntry[0]?.value;
          }
        }

        compProps.dispatch(change(compProps.form, fieldProps.name, cntryLbl));
      } else {
        // If the list of countries is not loaded then show the country code
        compProps.dispatch(
          change(
            compProps.form,
            fieldProps.name,
            actionObj.values[actionObj.fieldName]
          )
        );
      }
      // compProps.dispatch(
      //   change(
      //     compProps.form,
      //     fieldProps.name,
      //     geoPolData[actionObj.values["geo"]].countries[
      //       actionObj.values[actionObj.fieldName]
      //     ].label
      //   )
      // );
    } else if (eventType === "onChange") {
      //do nothing on change;
    }
  };

  static setStateType = (compProps, fieldProps, actionObj, eventType) => {
    // const geoPolData = store.getState().common.geoPolData;
    const countryStateMappingStoreData =
      store.getState().common.countryStateMappingData;

    if (eventType === "onLoad") {
      //   if (
      //     actionObj.values["billingCountry"] &&
      //     actionObj.values["geo"] &&
      //     geoPolData[actionObj.values["geo"]].countries[
      //       actionObj.values[actionObj.fieldName]
      //     ].states.length > 0
      //   ) {
      //     fieldProps.options =
      //       geoPolData[actionObj.values["geo"]].countries[
      //         actionObj.values[actionObj.fieldName]
      //       ].states;
      //     fieldProps.type = "select";
      //   } else {
      //     fieldProps.type = "textfield";
      //     if (fieldProps.options) {
      //       delete fieldProps.options;
      //     }
      //   }

      if (
        actionObj.values["billingCountry"] &&
        actionObj.values["geo"] &&
        countryStateMappingStoreData &&
        _.keys(countryStateMappingStoreData)?.length > 0 &&
        "country" in countryStateMappingStoreData &&
        countryStateMappingStoreData?.country?.length > 0
      ) {
        const filteredCountryFrmState =
          countryStateMappingStoreData?.country?.length > 0
            ? countryStateMappingStoreData?.country?.filter((cntry) => {
                return (
                  cntry?.countryCode?.toUpperCase() ===
                  actionObj?.values["billingCountry"]?.toUpperCase()
                );
              })
            : [];

        if (filteredCountryFrmState?.length > 0) {
          const [matchedCntry] = filteredCountryFrmState;
          if (matchedCntry && "states" in matchedCntry) {
            if (matchedCntry?.states?.length > 0) {
              // format the states to be stored in label-value pair
              const formattedStates = [];
              matchedCntry?.states?.forEach((state) => {
                formattedStates.push({
                  label: state?.value,
                  value: state?.stateIsoCode,
                });
              });

              // Once the state is formatted, lets sort it
              formattedStates.sort((a, b) => a.label - b.label);

              // assign it to the options
              fieldProps.options = formattedStates;
            } else {
              fieldProps.options = [
                {
                  label: "N/A",
                  value: "n/a",
                },
              ];
            }
          } else {
            fieldProps.options = [
              {
                label: "N/A",
                value: "n/a",
              },
            ];
          }
        } else {
          fieldProps.options = [
            {
              label: "N/A",
              value: "n/a",
            },
          ];
        }

        fieldProps.type = "select";
      } else {
        fieldProps.type = "textfield";
        if (fieldProps.options) {
          delete fieldProps.options;
        }
      }
    } else if (eventType === "onChange") {
      //do nothing onChange;
    }
  };

  // **********************************************************************************************
  // UPlevel

  static radiogroupDependentAction = (
    compProps,
    fieldProps,
    actionObj,
    eventType
  ) => {
    if (eventType === "onLoad" || eventType === "onChange") {
      if (actionObj.values[fieldProps.name] === "Yes") {
        compProps.field.map((obj) => {
          if (obj.name === actionObj.fieldName) {
            obj.hide = false;
          }
          return null;
        });
      } else {
        compProps.field.map((obj) => {
          if (obj.name === actionObj.fieldName) {
            obj.hide = true;
          }
          return null;
        });
      }
    }
  };

  static draftLevelAction = (compProps, fieldProps, actionObj, eventType) => {
    if (eventType === "onLoad") {
      if (
        actionObj.values["level"] &&
        actionObj.values["level"] === "Certified" &&
        fieldProps.radios.length > 1
      ) {
        fieldProps.radios = [fieldProps.radios[1]];
      }
    }
    if (eventType === "onChange") {
      //do nothing on change
    }
  };

  static disjointFieldAction = (
    compProps,
    fieldProps,
    actionObj,
    eventType
  ) => {
    if (eventType === "onLoad") {
      //do nothing on load
    }
    if (eventType === "onChange") {
      const array1 = actionObj.values[fieldProps.name]
        ? actionObj.values[fieldProps.name]
        : [];
      const array2 = actionObj.values[actionObj.fieldName]
        ? actionObj.values[actionObj.fieldName]
        : [];
      const filteredArray = array1.filter((value) => array2.includes(value));
      if (filteredArray.length > 0) {
        throwError(
          <Translate value={"uplevelRenewal." + [actionObj.error_key]} />
        );
      }
    }
  };
}
